import { getAnnotation } from '@gonfalon/openapi/operations/getAnnotation';
import { patchAnnotation } from '@gonfalon/openapi/operations/patchAnnotation';
import { putAnnotation } from '@gonfalon/openapi/operations/putAnnotation';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { createQueryOptions } from '../internal/createQueryOptions';

export const getAnnotationQuery = createQueryOptions(getAnnotation);

export const usePutAnnotation = createMutationHook(putAnnotation, {
  onSuccess: (data, { projKey, envKey, traceId, spanId }) => {
    getQueryClient().setQueryData(getAnnotationQuery({ projKey, envKey, traceId, spanId }).queryKey, data);
  },
});

export const usePatchAnnotation = createMutationHook(patchAnnotation, {
  onSuccess: (data, { projKey, envKey, traceId, spanId }) => {
    getQueryClient().setQueryData(getAnnotationQuery({ projKey, envKey, traceId, spanId }).queryKey, data);
  },
});
